import React, { useState, useContext, useEffect, useRef } from 'react';
import { Modal, Button, Col, Form, Row } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SplitNumber from '../../SplitNumber';
import _ from 'lodash';
import { useForm, Controller } from "react-hook-form";
// import { ArrowLeftShort, ArrowRightShort, PersonCircle, Phone } from 'react-bootstrap-icons';
import 'react-toastify/dist/ReactToastify.css';
import NumberFormat from 'react-number-format';
// import { BasketHelper } from '../../../core/utils/BasketHelper'
import ApiAuth from "../../../../core/api/api.auth";
import ServiceStorage from "../../../../core/services/service.storage";
import ContextApp from "../../../../core/contexts/context.app";
import { tools } from "../../../../core/utils/tools";
import ReCAPTCHA from 'react-google-recaptcha'

function LoginGetPhoneNumber(props) {
    const [isCaptchaRequired, setIsCaptchaRequired] = useState(false);



    const recaptcha = useRef();
    toast.configure();

    const ctx = useContext(ContextApp);
    // =======================================================================================================================
    var arabicNumberPattern = /[\u0660-\u0669]/;

    const { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, setFocus } = useForm();
    const [mobileLogin, setMobileLogin] = useState("");
    const numberPhonRef = useRef(null)
    async function getIsCaptchaRequired() {
        try {
            var result =await ApiAuth.isCaptchaRequired();
            setIsCaptchaRequired(result);
        }
        catch {
            setIsCaptchaRequired(true);
        }
    }

    useEffect(() => {
        getIsCaptchaRequired();
        numberPhonRef.current.focus()
      }, []);
    const onSubmit =
        async (data) => {
            const captchaValue = isCaptchaRequired ? recaptcha.current.getValue() : "";
            if (isCaptchaRequired && !captchaValue) {
                toast.error("لطفا صحت اعتبار سنجی گوگل را انجام دهید. جهت این کار بر روی من روبات نیستم کلیک کنید."
                    , {
                        duration: 10000,
                        position: 'top-center'
                    }
                );


                return;
            }
            let phoneNumber = mobileLogin.split(' ').join('');
            phoneNumber = phoneNumber[0] !== '0' ? "0" + phoneNumber : phoneNumber
            if (_.isEmpty(phoneNumber)) {
                // نمایش پیغام
                toast("لطفا شماره موبایل خود را وارد نمایید");
                return;
            }
            try {

                const result = await ApiAuth.login({ phoneNumber: phoneNumber, captchaValue: captchaValue });

                if (result.succeeded === true) {
                    toast.success(result.message);
                    // بستن مدال نمایش شماره تلفن و باز کردن دریافت کد 4 رقمی
                    props.setManageComponent({ ...props.manageComponent, modalId: 2, mobile: phoneNumber });

                }
                else {
                    recaptcha.current.reset();
                    toast.error(result.message, { position: 'top-center' });
                }
            } catch (error) {


            } finally {
            }
        }



    const handleIsKeydlete = (e) => {
        // if (e.key === 'Backspace' || e.key === 'Delete') {
        //     setIsKeyDelete(true)
        // } else {
        //     setIsKeyDelete(false)
        // }
    }

    // این تابع به دلیل اینکه مخاطبین محدود به ایران شده اند اجرا شده است در صورت تغییر این تابع باید ویرایش شود
    const handleReadyPhoneForSend = (e) => {

        let isKeyDelete = false;
        var number = tools.toEnDigit(e.target.value.split(' ').join(''));
        if (e.key === 'Backspace' || e.key === 'Delete') {

            isKeyDelete = true;
        }
        if (!isNaN(number) && !isKeyDelete) {
            if (number[0] === '0') {
                if (number.length > 4 && number.length <= 7) {
                    var newNum = number.slice(0, 4) + ' ' + number.slice(4)
                    setMobileLogin(newNum)
                } else if (number.length > 7) {
                    var newNum = number.slice(0, 4) + ' ' + number.slice(4, 7) + ' ' + number.slice(7)
                    setMobileLogin(newNum)
                } else {
                    setMobileLogin(e.target.value)
                }
            } else if (number[0] !== '0') {
                if (number.length > 3 && number.length <= 6) {
                    var newNum = number.slice(0, 3) + ' ' + number.slice(3)
                    setMobileLogin(newNum)
                } else if (number.length > 6) {
                    var newNum = number.slice(0, 3) + ' ' + number.slice(3, 6) + ' ' + number.slice(6)
                    setMobileLogin(newNum)
                } else {
                    setMobileLogin(number)
                }
            }
        } else if (isKeyDelete && !isNaN(number)) {
            setMobileLogin(e.target.value)
        }
    }

    return (
        <>
            <Form noValidate onSubmit={handleSubmit(onSubmit)}>
                <Row className=' mt-0 mt-xl-0 ' >
                    {/* {!props.loginGetPhoneNumber.isItModal &&
                            <Col xs='12' className='d-flex justify-content-start' onClick={() => props.setLoginGetPhoneNumber({ ...props.loginGetPhoneNumber, show: false })}>
                                <ArrowRightShort className="text-dark font-weight-bolder cursor-pointer " size={30} />
                            </Col>} */}
                    <Col xs='12' className=' d-flex justify-content-center my-3'>
                        <span className='text-dark font-weight-bold pr-0' style={{ fontSize: '1.4rem', fontWeight: '400' }}> ورود / ثبت نام</span>
                    </Col>
                    {/* <Col xs='12' className='d-flex justify-content-center '>
                        <span style={{ color: '#b3afaf' }}> <PersonCircle size={90} /> </span>
                    </Col> */}
                    <Col xs='12' className='mt-2 d-flex justify-content-center'>
                        <span className='text-dark font-weight-bold text-center' style={{ fontSize: '.8rem', fontWeight: '400' }}> لطفا شماره موبایل خود را وارد کنید</span>
                    </Col>
                    <Col xs='12' className='mt-1 py-0 d-flex justify-content-center'>
                        {!props.manageComponent.isItModal ?
                            <span className='text-muted my-0 py-0 text-center' style={{ fontSize: '.6rem', fontWeight: '400' }}>
                                کاربر گرامی برای ادامه  فرایند  نیاز به ورود یا ثبت نام در سامانه دارید <br />   جهت ورود یا ثبت نام لطفا
                                <span className='font-weight-bold text-dark px-1'>شماره موبایل </span>
                                خود را وارد نمایید
                            </span> :
                            <span className='text-muted my-0 py-0 text-center' style={{ fontSize: '.6rem', fontWeight: '400' }} >
                                برای ورود یا ثبت نام در سامانه لطفا
                                <span className='font-weight-bold text-dark px-1'>شماره موبایل </span>
                                خود را وارد نمایید <br /> کدی چهار رقمی به شماره موبایل شما ارسال خواهد شد
                            </span>}
                    </Col>
                    <Col xs='12' className='mt-4 d-flex justify-content-center'>
                        <Form.Group style={{ direction: "ltr" }} className='position-relative'  >
                            {/* <Phone className='float-left position-absolute' style={{ left: '10px', top: '12px' }} /> */}
                            <Form.Control
                                className='text-center rounded-pill '
                                type='tel'
                                style={{ direction: "ltr", width: '260px' }}
                                onKeyDown={handleIsKeydlete}
                                onChange={handleReadyPhoneForSend}
                                value={mobileLogin}
                                maxLength={mobileLogin[0] === '0' ? 13 : 12}
                                placeholder='شماره موبایل '
                                size='lg'
                                ref={numberPhonRef}
                            >
                            </Form.Control>
                            {/* <Controller
                                    name="phoneNumber"
                                    control={control}
                                    // rules={{ required: true, }}
                                    render={({ field: { onChange, value } }) => (
                                        <NumberFormat
                                            customInput={Form.Control}
                                            className='text-center rounded-pill '
                                            style={{ direction: "ltr", width: '260px' }}
                                            label="شماره موبایل"
                                            size='lg'
                                            margin="normal"
                                            value={value || ""}
                                            // dir="ltr"
                                            // thousandSeparator=","
                                            // decimalScale="0"
                                            //prefix=" تومان "
                                            format="#### ### ####"
                                            onChange={onChange}
                                            ref={numberPhonRef}
                                        />
                                    )}
                                /> */}
                        </Form.Group>
                    </Col>
                    <Col>

                        {isCaptchaRequired &&
                            <ReCAPTCHA ref={recaptcha} hl={"fa"} sitekey={process.env.REACT_APP_Recaptcha_SITE_KEY} />
                        }
                    </Col>
                    <Col xs='12' className='mt-3  mb-2 d-flex justify-content-center' >

                        <Button variant="success" type="submit" disabled={isSubmitting} className="rounded-pill">
                            <p>ورود / ثبت نام</p>
                        </Button>
                    </Col>
                </Row>
            </Form>
        </>
    )
}

export default LoginGetPhoneNumber;


